import { HttpClient } from '@angular/common/http';
import { Component, DestroyRef, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Store, select } from '@ngrx/store';
import { Session } from 'core/session.service';
import { BasicTeamModel } from 'models';
import { AppState } from 'store';

import { MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatButton } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-switch-team-modal',
    templateUrl: './switch-team-modal.component.html',
    styleUrls: ['./switch-team-modal.component.scss'],
    imports: [
        MatDialogTitle,
        CdkScrollable,
        MatDialogContent,
        MatProgressSpinner,
        MatDialogActions,
        MatButton,
        MatDialogClose,
        TranslateModule,
    ],
})
export class SwitchTeamModalComponent implements OnInit {
    private readonly session = inject(Session);
    private readonly store = inject<Store<AppState>>(Store);
    private readonly http = inject(HttpClient);

    #destroyRef = inject(DestroyRef);

    public currentTeam = 0;
    public teams: Array<BasicTeamModel>;
    public isSwitching = false;

    constructor() {
        const session = this.session;

        this.currentTeam = session.user.idTeam;
    }

    ngOnInit(): void {
        this.store
            .pipe(
                select((x) => x.user.current.teams),
                takeUntilDestroyed(this.#destroyRef),
            )
            .subscribe((teams) => (this.teams = teams));
    }

    public selectTeam(team: BasicTeamModel) {
        if (this.currentTeam !== team.id) {
            this.isSwitching = true;
            this.session.switchTeam(team.id);
        }
    }

    public createNewTeam() {
        this.http.delete('/api/teams/clear-selected').subscribe(() => {
            window.location.href = '/account/create/2';
        });
    }
}
